import React, { useEffect, useState } from 'react';
import { Button, TextField, Select, MenuItem, FormControl, InputLabel, FormControlLabel, Checkbox, Grid, Switch, Box } from '@mui/material';
import apiInstance from '../../../services/ServiceApi';
import CampoDinamico from './CampoDinamico';
import { COMPONENTES_DISPONIBLES } from '../../../utilities/constant';

function ConstructorFormulario({ formulario, linea_negocio_id }) {
    const [campos, setCampos] = useState(formulario || []);
    const [campoActual, setCampoActual] = useState({ 
        tipo: '', 
        label: '', 
        opciones: [], 
        columnas: 12, 
        requerido: false, 
        dependencias: {}, 
        mostrarOpcionalmente: false 
    });
    const [campoSeleccionado, setCampoSeleccionado] = useState(null);
    const [campoConMouse, setCampoConMouse] = useState(null);
    const [camposSelect, setCamposSelect] = useState([]);

    useEffect(() => {
        setCamposSelect(campos.filter(campo => campo.tipo === 'select'));
    }, [campos]);
    useEffect(() => {
        setCampos(formulario || []);
    }, [formulario]);

    const manejarSeleccion = (e, index) => {
        const valor = e.target.value;
        const nuevosCampos = [...campos];
        // Para cada campo, comprueba si existe una dependencia con el campo select que ha cambiado
        nuevosCampos.forEach((campo, i) => {
            if (campo.dependencias[campos[index].label] && campo.dependencias[campos[index].label] === valor) {
                // Si la dependencia se cumple y el campo se muestra opcionalmente, no cambia el estado de requerido
                if (!campo.mostrarOpcionalmente) {
                    campo.requerido = true;
                }
            } else if (campo.dependencias[campos[index].label]) {
                // Si la dependencia no se cumple, marca este campo como no requerido
                campo.requerido = false;
            }
        });
        setCampos(nuevosCampos);
    };
    
    const agregarCampo = () => {
        if (esEtiquetaUnica(campoActual.label)) {
            setCampos([...campos, campoActual]);
            setCampoActual({ tipo: '', label: '', opciones: [], columnas: 12, requerido: false, dependencias: {}, mostrarOpcionalmente: false });
    
        } else {
            alert('La etiqueta del campo debe ser única.');
        }
    };

    const esEtiquetaUnica = (label) => {
        return !campos.some(campo => campo.label === label);
    };

    const seleccionarCampo = (index) => {
        setCampoActual(campos[index]);
        setCampoSeleccionado(index);
    };

    const guardarCampo = () => {
        if (esEtiquetaUnica(campoActual.label) || campoActual.label === campos[campoSeleccionado].label) {
            const nuevosCampos = [...campos];
            nuevosCampos[campoSeleccionado] = campoActual;
            setCampos(nuevosCampos);
            setCampoActual({ tipo: '', label: '', opciones: [], columnas: 12, requerido: false, dependencias: {}, mostrarOpcionalmente: false });
            setCampoSeleccionado(null);
        } else {
            alert('La etiqueta del campo debe ser única.');
        }
    };

    const eliminarCampo = (index) => {
        const nuevosCampos = [...campos];
        nuevosCampos.splice(index, 1);
        setCampos(nuevosCampos);
        if (index === campoSeleccionado) {
            setCampoActual({ tipo: '', label: '', opciones: [], columnas: 12, requerido: false });
            setCampoSeleccionado(null);
        }
    };
    const guardarFormulario = async () => {
        try {
            const res = await apiInstance.put(`linea_negocio_form/${linea_negocio_id}/`, {
                formulario: campos,
            });
            alert('Formulario guardado con éxito');

        } catch (error) {
            alert('Error al guardar el formulario');
        }
    };

    const renderCampo = (campo, index) => {
        return (
            <Grid item xs={12} md={campo.columnas} key={index}
                style={{ padding: '10px', position: 'relative' }}
                onMouseEnter={() => setCampoConMouse(index)}
                onMouseLeave={() => setCampoConMouse(null)}
            >
                <CampoDinamico campo={campo} manejarSeleccion={manejarSeleccion} index={index} componentesDisponibles={COMPONENTES_DISPONIBLES} />

                {campoConMouse === index &&
                    <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                        <Button onClick={() => seleccionarCampo(index)}>Editar</Button>
                        <Button onClick={() => eliminarCampo(index)}>Eliminar</Button>
                    </div>
                }
                
            </Grid>
        );
    };
    return (
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Grid container spacing={4} direction={'row'}>
                <Grid item xs={12} md={4} >
                    <TextField
                        label="Etiqueta"
                        value={campoActual.label}
                        onChange={(e) => setCampoActual({ ...campoActual, label: e.target.value })}
                        variant="outlined"
                        style={{ marginBottom: '10px' }}
                        fullWidth
                    />
                    {camposSelect.length > 0 && (
                        <FormControl variant="outlined" style={{ marginBottom: '10px' }} fullWidth>
                            <InputLabel>Dependencia</InputLabel>
                            <Select
                                value={Object.keys(campoActual.dependencias)[0] || ''}
                                onChange={(e) => {
                                    const labelDependencia = e.target.value;
                                    const opcionDependencia = camposSelect.find(campo => campo.label === labelDependencia).opciones[0];
                                    setCampoActual({ ...campoActual, dependencias: { [labelDependencia]: opcionDependencia } });
                                }}
                            >
                                {camposSelect.map((campo, index) => <MenuItem value={campo.label} key={index}>{campo.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    )}

                    {Object.keys(campoActual.dependencias).length > 0 && (
                        <FormControl variant="outlined" style={{ marginBottom: '10px' }} fullWidth>
                            <InputLabel>Opción de dependencia</InputLabel>
                            <Select
                                value={campoActual.dependencias[Object.keys(campoActual.dependencias)[0]]}
                                onChange={(e) => setCampoActual({
                                    ...campoActual,
                                    dependencias: { [Object.keys(campoActual.dependencias)[0]]: e.target.value }
                                })}
                            >
                                {(campos.find(campo => campo.label === Object.keys(campoActual.dependencias)[0])?.opciones || []).map((opcion, index) => <MenuItem value={opcion} key={index}>{opcion}</MenuItem>)}
                            </Select>
                        </FormControl>
                    )}

                    <FormControl variant="outlined" style={{ marginBottom: '10px' }} fullWidth>
                        <InputLabel>Tipo</InputLabel>
                        <Select
                            value={campoActual.tipo}
                            onChange={(e) => setCampoActual({ ...campoActual, tipo: e.target.value })}
                        >
                            <MenuItem value="texto">Texto</MenuItem>
                            <MenuItem value="numero">Número</MenuItem>
                            <MenuItem value="decimal">Decimal</MenuItem>
                            <MenuItem value="correo">Correo</MenuItem>
                            <MenuItem value="select">Select</MenuItem>
                            <MenuItem value="checkbox">Checkbox</MenuItem>
                            <MenuItem value="date">Date</MenuItem>
                            <MenuItem value="dependencia">Depende Componente</MenuItem>
                        </Select>
                    </FormControl>
                    {campoActual.tipo === 'dependencia' && (
                        <FormControl variant="outlined" style={{ marginBottom: '10px' }} fullWidth>
                            <InputLabel>Selecciona Componente</InputLabel>
                            <Select
                                value={campoActual.nombreComponente || ''}
                                onChange={(e) => setCampoActual({ ...campoActual, nombreComponente: e.target.value })}
                            >
                                {Object.keys(COMPONENTES_DISPONIBLES).map((nombreComponente) => (
                                    <MenuItem value={nombreComponente} key={nombreComponente}>
                                        {nombreComponente}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    {campoActual.tipo === 'select' &&
                        <TextField
                            label="Opciones (separadas por comas)"
                            value={campoActual.opciones.join(',')}
                            onChange={(e) => setCampoActual({ ...campoActual, opciones: e.target.value.split(',') })}
                            variant="outlined"
                            style={{ marginBottom: '10px' }}
                            fullWidth
                        />
                    }
                    {campoActual.tipo === 'numero' &&
                        <TextField 
                            label="Dígitos Límite" 
                            type="number" 
                            value={campoActual.digitosLimite || ''} 
                            onChange={(e) => setCampoActual({ ...campoActual, digitosLimite: Math.max(e.target.value, 1) })}
                            variant="outlined" 
                            style={{ marginBottom: '10px' }}
                        />
                    }
                    <FormControlLabel
                        control={
                            <Switch
                                checked={campoActual.requerido}
                                onChange={(e) => setCampoActual({ ...campoActual, requerido: e.target.checked })}
                                name="Requerido"
                            />
                        }
                        label="Requerido"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                            checked={campoActual.mostrarOpcionalmente || false}
                            onChange={(e) => setCampoActual({ ...campoActual, mostrarOpcionalmente: e.target.checked })}
                            />
                        }
                        label="Mostrar de manera opcional"
                        />
                    <TextField
                        label="Columnas"
                        type="number"
                        value={campoActual.columnas}
                        onChange={(e) => setCampoActual({ ...campoActual, columnas: Math.min(Math.max(e.target.value, 1), 12) })}
                        variant="outlined"
                        style={{ marginBottom: '10px' }}
                    />
                    {campoSeleccionado !== null ?
                        <Button variant="contained" onClick={guardarCampo}>Guardar Cambios</Button> :
                        <Button variant="contained" onClick={agregarCampo}>Agregar Campo</Button>
                    }
                </Grid>
                <Grid container item xs={12} md={8} >
                    <Grid container spacing={2}>
                        {campos.map(renderCampo)}
                    </Grid>
                </Grid>
            </Grid>
            <Button onClick={guardarFormulario} variant="contained" color="success">
                    Guardar Formulario
            </Button>
        </Box>
    );
}

export default ConstructorFormulario;
